import script from "./VecuraTeaser.vue?vue&type=script&setup=true&lang=ts"
export * from "./VecuraTeaser.vue?vue&type=script&setup=true&lang=ts"

import "./VecuraTeaser.vue?vue&type=style&index=0&id=3014f4b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3014f4b1"]])

export default __exports__